<template>
  <dv-border-box-12
                :color="['#09557a', '#27dbe9']"
                backgroundColor="rgba(0, 21, 35,.7)"
                style="height: 320px"
              >
                <div class="com-title">
                  停车场车辆<dv-decoration-3 style="width: 100px; height: 20px" />
                </div>
                <div style="padding: 0 15px;">
                  <dv-capsule-chart :config="dataVal" style="width:100%;height:260px" />
                  <!-- <Echart id="leftBottom" :options="options" width="100%" height="290px" v-if="pageflag" ref="charts" /> -->
				  <!-- <dv-scroll-board :config="dataVal" style="width:100%;height:260px" @click="tapsq" /> -->
                </div>
              </dv-border-box-12>
</template>

<script>
export default {
  data() {
    return {
      pageflag: true,
      dataret: {
        data: [
        {
          name: '南阳',
          value: 167
        },
        {
          name: '周口',
          value: 67
        },
        {
          name: '漯河',
          value: 123
        },
        {
          name: '郑州',
          value: 55
        },
        {
          name: '西峡',
          value: 98
        },
        {
          name: '周口11',
          value: 67
        },
        {
          name: '漯河22',
          value: 123
        },
        {
          name: '郑州33',
          value: 55
        },
        {
          name: '西峡44',
          value: 98
        },
      ],
      unit: '单位'
      },
	  config: {
		  rowNum: 8,
		  columnWidth: [270],
		  data: [
		      ['xxx社区道理拥堵问题', '<span style="color:#67e0e3;">处理完毕</span>', '2023-02-28'],
		      ['xxx小区下水道堵塞', '<span style="color:#67e0e3;">处理完毕</span>', '2023-02-28'],
		      ['xxx小区周边商铺乱停车', '<span style="color:#67e0e3;">处理完毕</span>', '2023-02-28'],
		     ['xxx社区道理拥堵问题', '<span style="color:#67e0e3;">处理完毕</span>', '2023-02-28'],
		     ['xxx小区下水道堵塞', '<span style="color:#fd8a47;">尚未处理</span>', '2023-02-28'],
		      ['xxx小区周边商铺乱停车', '<span style="color:#67e0e3;">处理完毕</span>', '2023-02-28'],
		      ['xxx社区道理拥堵问题', '<span style="color:#fff;">正在处理</span>', '2023-02-28'],
		      ['xxx小区下水道堵塞', '<span style="color:#67e0e3;">处理完毕</span>', '2023-02-28'],
		      ['xxx小区周边商铺乱停车', '<span style="color:#fd8a47;">尚未处理</span>', '2023-02-28'],
		     
		    ]
	  },
      options: {},
      timer: null
    }
  },
  props: {
  	  dataVal: {
  	        type: Object,
  	        default: () => ({})
  	      }
  },
  // watch: {
  // 	  dataVal: {
  // 		  handler(newData) {
  // 			  this.$nextTick(() => {
  // 				  this.getData()
  // 			  })
  // 		  },
  // 		  immediate: true,
  // 		  deep: true
  // 	  }
  // },
  mounted() {
    // this.getData()
  },
  beforeDestroy() {
    this.clearData()
  },
  methods: {
    tapsq(e) {
      this.$emit("openShow",{name:"LeftBottom",val: e.rowIndex})
    },
    getData() {
        
    },
    clearData() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
  }
}
</script>
